import styled from 'styled-components';

const StoreRulesStyled = styled.div`
  .basic-cycle {
    margin-top: ${(props) => props.theme.spacing(49 / 8)};
  }
  .cycle-select-wrap {
    display: flex;
    flex-direction: row;
  }
  .company-select-wrap {
    display: flex;
    flex-direction: row;
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .campaign_area {
    width: 81px;
    height: 24px;
    font-size: 14px;
    margin-top: 41px;
    margin-bottom: 60px;
    font-weight: 400;
    color: #000;
    line-height: 24px;
  }
  .mention {
    font-weight: 400;
    color: #616161;
    line-height: 17px;
    font-size: 12px;
  }
  .area {
    width: 81px;
    height: 40px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
  }
`;

export default StoreRulesStyled;
